import React, { memo, Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteRutas, ImagenesRutas } from "../../request/RutasConfig";
import LiquidarOrdenInt from "./Interfaz/liquidarOrdenInt.jsx"
import {
    Exp_Orden_Encabezado_Par_Detalle, Listar_Ordenes_A_Pantalla_Gen, Exp_Orden_Tipo_Pagos, Exp_Orden_Encabezado_Detalle, AnalisisTiempoOrden_Listar, Liquidar_Orden_Express,
    ExpSuborden_Encabezado_Listar_Gen, Listar_ParametrosGenerales
} from "../../request/ProcesosRequest";
import { Obtener_Estado_Active_Directory_Request } from '../../request/ParametroRequest';
import { Tiempos_Lista, Cliente_Detalle } from "../../request/MantenimientosRequest"

import { Obtener_MenuOpciones } from "../../request/MenuRequest";
import Config from '../../components/Util/Constantes';
import { farmatearMontos, validarInt, toDDHHMMSS } from '../../components/Util/Util.js'
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import moment from 'moment';
import ModalSeguridad from "../Seguridad/ModalSeguridad.jsx";
import Swal from "sweetalert2";
import LocalStorage from '../../components/Util/LocalStorage/LocalStorage';

const localStorageObject = new LocalStorage();

class LiquidarOrden extends Component {

    state = {
        activoAD: false,
        activoAD: false,
        fecha_activa: new Date(), listaOrdenes: [], listaSubOrdenes: [], estadoOrdenes: '', ControlMonitoreo: {}, ParamCallCenter: {},
        ordenUbicacion: {
            Fecha: '', Orden: '', Estado: '', Disponible: '', Telefono: '', Nombre: '', coordenada: '', Ubicacion: '', Localidad: '', Observaciones: '', Peso: '', Cubicaje: '', Transporte: '', Apoyo: "", Tipo_Entrega: '',
            Ubicacion_Id: '', Correo: '', Suc_Factura: -1, Disponible_Positivo: false, DireccionAdic: '', sucFact: -1
        },
        esEcommerce: false, ordenGrupo: '', articulos: [], articulosAp: [], sucApoyo: [], sucTiempo: [], filtro: '', center: [this.props.mapa.Latitud, this.props.mapa.Longitud], zoom: 4,
        bingmapKey: this.props.mapa.Llave, infoboxes: [], pushPins: [], directions: {},
        boundary: { "search": `${this.props.mapa.Latitud.toString()} , ${this.props.mapa.Longitud.toString()}`, "polygonStyle": { fillColor: 'rgba(161,224,255,0.4)', strokeColor: '#a495b2', strokeThickness: 2 }, "option": { entityType: 'PopulatedPlace' } },
        articulosTotales: [], Estructura_Disponible_Orden: { Disponible: new Date(), Duracion: new Date(), Disponible_Positivo: false, Estatus_Suborden: 0, Estatus_subOrdenNombre: '' }, parametrosGenerales: [],
        OrdenId: '', debeRefrescar: false, intervalo: 0, Cliente: {},
        Datos: {
            Emp_id: { value: 0, attributes: { readOnly: true, focus: false, hidden: "none", label: "", }, },
            CC_Id: { value: 0, attributes: { readOnly: true, focus: false, hidden: "unset", label: "ID", }, },
            OrdenId: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "", }, },
            Entrega: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Entrega", }, },
            Fecha: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Fecha", }, },
            Usuario: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Usuario", }, },
            Monto: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Monto" }, },
            Cliente: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Cliente", }, },
            Tiempo: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Tiempo", }, },
            Repartidor: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Repartidor" }, },
            Estatus: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Estatus", }, },
            Factura: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Factura", }, },
            Codigo: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Código" }, },
            NitIde: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Nit Ide55", }, },
            Nombre: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Nombre", }, },
            Email: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Email", }, },
            Entregar: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Entregar", }, },
            Repartidor_Id: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Repartidor ID", }, },
            Telefono: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Teléfono", }, },
        }, listPagos: [], listTiempos: [], IdTributarioLabel: 'Cédula',
        columnasPagos: [{ dataField: 'llave', text: 'llave', sort: true, hidden: true }, { dataField: 'Nombre_Tipo', text: 'Tipo', sort: true }, { dataField: 'Pago_Total', text: 'Monto', sort: true, align: 'left', formatter: (row, cell) => { return farmatearMontos(cell.Pago_Total) }, },
        { dataField: 'Moneda_Numero', text: 'Moneda/Núm. Tarjeta', sort: true }, { dataField: 'Tarjeta_Nombre', text: 'Tarjeta/Banco', sort: false, editable: true }, { dataField: 'Tarjeta_Aprobacion', text: 'Autorizado', sort: false }],
        columnasTiempos: [{ dataField: 'llave', text: 'llave', sort: true, hidden: true }, { dataField: 'Estatus', text: 'Sitio', sort: true }, { dataField: 'EntroTxt', text: 'Entró', sort: true }, { dataField: 'SalioTxt', text: 'Salió', sort: true },
        { dataField: 'Duracion', text: 'Duración', sort: false, editable: true }, { dataField: 'Designado', text: 'Designado', sort: false, editable: true }, { dataField: 'Retraso', text: 'Retraso', sort: true }],
        menuId: 0, menuOpciones: [], showModalSeguridad: false, opcionValidar: 0,
        tiemposDetalle: {
            Orden: 0,
            EstadoOrden: 'normal',
            Despacho: 0,
            EstadoDespacho: 'normal',
            Factura: 0,
            EstadoFactura: 'normal',
            Ruta: 0,
            EstadoRuta: 'normal'
        }.liquidar = false
    }

    componentDidMount = async () => {
        this.obtenerEstadoActiveDirectory();
        let mensajeVA = '';
        localStorageObject.set("UID", -1);
        if (this.props.callCenter.Id <= 0) {
            mensajeVA = 'No se ha seleccionado un call center en los parámetros';
        }
        if (this.props.sucursal.Id <= 0) {
            if (mensajeVA.length > 0) {
                mensajeVA = 'No se ha seleccionado ni un call center y ni una sucursal en los parámetros';
            } else {
                mensajeVA = 'No se ha seleccionado una sucursal en los parámetros';
            }
        }

        if (mensajeVA.length > 0) {
            Notificacion.error(mensajeVA);
            this.props.history.replace(SiteRutas.Home);
        }

        this._isMounted = true;
        let menuId = 0;

        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        let menuOpciones = null;

        if (menuId > 0) {
            let response = await Obtener_MenuOpciones(this.props.token, menuId);
            if (response.Exitoso) {
                menuOpciones = response.Datos;
            } else {
                Notificacion.error(response.Mensaje);
            }
        }
        const tiemposDetalle = {
            Orden: 0,
            EstadoOrden: 'normal',
            Despacho: 0,
            EstadoDespacho: 'normal',
            Factura: 0,
            EstadoFactura: 'normal',
            Ruta: 0,
            EstadoRuta: 'normal'
        };
        const parametrosGenerales = await this.cargarParametrosGenerales();
        const IdTributarioLabel = parametrosGenerales.Identificacion_Tributaria;
        let Datos = this.state.Datos;
        Datos.NitIde.attributes.label = IdTributarioLabel;


        let pushPins = [
            { "location": [parseFloat(this.props.mapa.Latitud), parseFloat(this.props.mapa.Longitud)], "option": { title: ``, color: 'green', icon: ImagenesRutas.Ping }, "addHandler": { "type": "click", callback: () => { } } }
        ]
        let directions = { "requestOptions": { "routeMode": "driving", "maxRoutes": 4 }, "wayPoints": [{ "location": [parseFloat(this.props.mapa.Latitud), parseFloat(this.props.mapa.Longitud)] }] }

        this.setState({ menuId, menuOpciones, tiemposDetalle, IdTributarioLabel, Datos, pushPins, directions });

    };

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };
    onKeyPressBuscar = (e) => {

        const _OrdenId = e.target.value.toString().trim();
        if (e.charCode == 13) {
            if (_OrdenId.length > 0) {
                this.buscarOrden(_OrdenId);
            }
        }

    }

    onChangeBuscar = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const valido = validarInt(value);
        if (valido) {
            this.limpiaPantalla();
            const OrdenId = value;
            this.setState({ OrdenId });
        }

    }

    limpiaPantalla = () => {
        const Datos = this.inicializaDatos();
        const ordenUbicacion = this.inicializaOrdenSelect();
        const articulosTotales = [];
        const articulos = [];
        const articulosAp = [];
        const zoom = 4;
        const infoboxes = [];
        const pushPins = [];
        const directions = {};
        const listPagos = [];
        const listTiempos = [];
        const boundary = { "search": `${this.props.mapa.Latitud.toString()} , ${this.props.mapa.Longitud.toString()}`, "polygonStyle": { fillColor: 'rgba(161,224,255,0.4)', strokeColor: '#a495b2', strokeThickness: 2 }, "option": { entityType: 'PopulatedPlace' } };
        const tiemposDetalle = {
            Orden: 0,
            EstadoOrden: 'normal',
            Despacho: 0,
            EstadoDespacho: 'normal',
            Factura: 0,
            EstadoFactura: 'normal',
            Ruta: 0,
            EstadoRuta: 'normal'
        };
        const liquidar = false;
        localStorageObject.set("UID", -1);
        this.setState({ ordenUbicacion, articulosTotales, articulosAp, articulos, zoom, infoboxes, pushPins, directions, boundary, listPagos, listTiempos, Datos, tiemposDetalle, liquidar });

    }


    inicializaDatos = () => {
        const IdTributarioLabel = this.state.IdTributarioLabel;
        return {
            Emp_id: { value: 0, attributes: { readOnly: true, focus: false, hidden: "none", label: "", }, },
            CC_Id: { value: 0, attributes: { readOnly: true, focus: false, hidden: "unset", label: "ID", }, },
            OrdenId: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "", }, },
            Entrega: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Entrega", }, },
            Fecha: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Fecha", }, },
            Usuario: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Usuario", }, },
            Monto: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Monto" }, },
            Cliente: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Cliente", }, },
            Tiempo: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Tiempo", }, },
            Repartidor: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Repartidor" }, },
            Estatus: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Estatus", }, },
            Factura: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Factura", }, },
            Codigo: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Código" }, },
            NitIde: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: IdTributarioLabel, }, },
            Nombre: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Nombre", }, },
            Email: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Email", }, },
            Entregar: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Entregar", }, },
            Repartidor_Id: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Repartidor ID", }, },
            Telefono: { value: "", attributes: { readOnly: false, focus: false, hidden: "unset", label: "Teléfono", }, },
        }
    }

    inicializaOrdenSelect = () => {
        return {
            Fecha: '', Orden: '', Estado: '', Disponible: '', Telefono: '', Nombre: '', coordenada: '', Ubicacion: '', Localidad: '',
            Observaciones: '', Peso: '', Cubicaje: '', Transporte: '', Apoyo: "", Tipo_Entrega: '', Ubicacion_Id: '', Correo: '', Suc_Factura: -1, Disponible_Positivo: false, DireccionAdic: '', sucFact: -1
        };
    }

    cargarParametrosGenerales = async () => {
        if (this.props.token) {
            const response = await Listar_ParametrosGenerales(this.props.token);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return {}
            }
        }
    }

    onClickBuscar = () => {
        //const Datos = this.state.Datos;
        const OrdenId = this.state.OrdenId;

        if (OrdenId.toString().length > 0) {
            this.buscarOrden(OrdenId);
        } else {
            Notificacion.error('Debe ingresar una número de orden');
        }
    }

    onClickLiquidar = () => {
        const Datos = this.state.Datos;
        if (Datos.OrdenId.value.toString().length > 0) {
            if (this.state.liquidar) {
                let validar = this.validarMenuOpcion();
                if (!validar) {
                    this.liquidar_Orden(Datos.OrdenId.value, Datos.Repartidor_Id.value);
                }
            }
        } else {
            Notificacion.error('Debe ingresar una número de orden');
        }
    }

    onActionResultModal = (pValido) => {
        if (pValido) {
            this.setState({ showModalSeguridad: false, opcionValidar: 0 });
            const Datos = this.state.Datos;
            this.liquidar_Orden(Datos.OrdenId.value, Datos.Repartidor_Id.value);
        }
    }

    handleCerrarModal = () => this.setState({ showModalSeguridad: false });

    cargarCliente = async (pCliente) => {
        if (this.props.token) {
            const response = await Cliente_Detalle(this.props.token, this.props.empresa.Id, -1, pCliente);
            return response;
        }
    }

    validarMenuOpcion = () => {
        let validar = false;
        let menuOpciones = this.state.menuOpciones;

        let resultado = menuOpciones.filter((item) => item.Opcion_Id == Config.m_LiquidarOrdenes);
        if (resultado.length > 0) {
            if (resultado[0].Validar) {
                this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id, });
                validar = true;
            }
        } else {
            this.setState({ showModalSeguridad: true, opcionValidar: resultado[0].Opcion_Id, });
            validar = true;
            //Notificacion.error('No existe opción en la seguridad');
        }

        return validar;
    };

    cargar_Orden_Encabezado_Par_Detalle = async (pOrden) => {
        if (this.props.token) {
            const response = await Exp_Orden_Encabezado_Par_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                //Notificacion.error(response.Mensaje);
                return null;
            }
        }
    }

    cargar_Orden_Encabezado_Detalle = async (pOrden) => {
        if (this.props.token) {
            const response = await Exp_Orden_Encabezado_Detalle(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                //Notificacion.error(response.Mensaje);
                return null;
            }
        }
    }

    cargar_Orden_Tipo_Pagos = async (pOrden, pEsPar) => {
        if (this.props.token) {
            const response = await Exp_Orden_Tipo_Pagos(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden, pEsPar);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                //Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    obtenerArticulos = async (pOrden, pEsPar) => {
        if (this.props.token) {
            const response = await Listar_Ordenes_A_Pantalla_Gen(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden, pEsPar);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    obtenerAnalisisTiempo = async (pOrden) => {
        if (this.props.token) {
            const response = await AnalisisTiempoOrden_Listar(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargar_Suborden_Encabezado_Par_Listar = async (pOrden, pEsPar) => {
        if (this.props.token) {
            const response = await ExpSuborden_Encabezado_Listar_Gen(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden, pEsPar);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    cargarDatos = async (pOrden) => {

        let Datos = this.state.Datos;

        const _Cliente = await this.cargarCliente(pOrden.Cliente_Id);

        const active_date = new Date();
        const fecha_activa = new Date(moment.utc().year(active_date.getFullYear()).month(active_date.getMonth()).date(active_date.getDate()).endOf('day').toISOString());
        let _Fecha_Hora_Actual = new Date();
        if (moment(pOrden.Fec_Terminada).format("yyyyMMdd") == moment(new Date("1900/01/01")).format("yyyyMMdd")) {
            _Fecha_Hora_Actual = fecha_activa;
        } else {
            _Fecha_Hora_Actual = new Date(pOrden.Fec_Terminada);
        }


        let _Disponible = new Date("1970/01/01");
        let _Duracion = new Date("1970/01/01");
        let _Tiempo_Orden = new Date("1970/01/01");
        let _Fin_Registro = new Date(pOrden.Fin_Registro);
        _Duracion.setSeconds(Math.abs(((_Fin_Registro.getTime() - _Fecha_Hora_Actual.getTime()) / 1000)));

        _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Orden.getTime()) / 1000)));

        Datos.Emp_id.value = pOrden.Emp_Id;
        Datos.CC_Id.value = pOrden.CC_Id;
        Datos.OrdenId.value = pOrden.Orden_Id;
        Datos.Entrega.value = pOrden.Tipo_Entrega === "PU" ? ' Tienda' : ' Domicilio';
        Datos.Fecha.value = pOrden.Inicio_RegistroStr;
        Datos.Usuario.value = pOrden.Usuario_Registro;
        Datos.Monto.value = farmatearMontos((pOrden.Total - pOrden.Redondeo));
        Datos.Cliente.value = pOrden.Cliente_Id;
        Datos.Tiempo.value = toDDHHMMSS(pOrden.Tipo_Trancurrido).join('');
        Datos.Repartidor.value = pOrden.Repartidor_Nombre;
        Datos.Estatus.value = pOrden.EstatusNombre;
        Datos.Factura.value = pOrden.Suc_Factura.toString() + " - " + pOrden.Suc_NombreFact;
        Datos.Codigo.value = _Cliente.Cliente_Id;
        Datos.NitIde.value = _Cliente.Cedula;
        Datos.Nombre.value = pOrden.Ecommerce && pOrden.Cliente_Nombre ? pOrden.Cliente_Nombre : _Cliente.Nombre;
        Datos.Email.value = _Cliente.Email;
        Datos.Entregar.value = _Cliente.Direccion;
        Datos.Repartidor_Id.value = pOrden.Repartidor_Id;
        Datos.Telefono.value = pOrden.Ubicacion_Id;
        Datos.Instrucciones_Entrega = pOrden.Instrucciones_Entrega;
        return Datos
    }

    buscarOrden = async (pOrden) => {

        let ordenUbicacion = this.state.ordenUbicacion;
        const listTiempos = await this.obtenerAnalisisTiempo(pOrden);
        let _Orden = await this.cargar_Orden_Encabezado_Par_Detalle(pOrden);
        let Espar = true;
        if (!_Orden) {
            _Orden = await this.cargar_Orden_Encabezado_Detalle(pOrden);
            Espar = false;
        }

        if (_Orden) {

            let listPagos = await this.cargar_Orden_Tipo_Pagos(_Orden.Orden_Id, Espar);
            let liquidar = !_Orden.Liquidada;

            if (liquidar) {
                liquidar = _Orden.Estatus_id === Config.c_Estatus_Ruta || _Orden.Estatus_id === Config.c_Estatus_Terminada;
            }
            //const OrdenId = _Orden.Orden_Id;
            const esEcommerce = _Orden.Ecommerce;
            const ordenGrupo = esEcommerce ? _Orden.Eco_Venta_Id : _Orden.Orden_Id;

            const Datos = await this.cargarDatos(_Orden);

            ordenUbicacion.Orden = _Orden.Orden_Id.toString();
            ordenUbicacion.Fecha = _Orden.fechaStr;
            ordenUbicacion.sucFact = _Orden.Suc_Factura;
            ordenUbicacion.Disponible = _Orden.Disponible;
            ordenUbicacion.Telefono = _Orden.Telefono;
            if (!_Orden.Ecommerce) {
                ordenUbicacion.Telefono = _Orden.Ubicacion_Id;
            }
            ordenUbicacion.Nombre = esEcommerce ? _Orden.Cliente_Nombre : _Orden.Ubicacion_Nombre;
            ordenUbicacion.Coordenada = '';
            ordenUbicacion.Ubicacion = ` ${_Orden.Nivel1_Nombre}, ${_Orden.Nivel2_Nombre}, ${_Orden.Nivel3_Nombre}, ${_Orden.Nivel4_Nombre}`;
            ordenUbicacion.Localidad = _Orden.Tipo_Entrega === 'EX' ? (_Orden.Ubicacion_Localidad.length > 0 ? `${_Orden.Ubicacion_Localidad} : ${_Orden.Ubicacion_Num_Localidad} ` : _Orden.Ubicacion_Num_Localidad) : '';
            ordenUbicacion.DireccionAdic = `${_Orden.Ubicacion_Referencia} ${_Orden.Ubicacion_Direccion}`;
            ordenUbicacion.Observaciones = _Orden.Observaciones;
            ordenUbicacion.Peso = _Orden.PesoTotal;
            ordenUbicacion.Cubicaje = _Orden.CubicajeTotal;
            ordenUbicacion.Transporte = _Orden.TipoVehiculo;
            ordenUbicacion.Apoyo = _Orden.Apoyo;
            ordenUbicacion.Tipo_Entrega = _Orden.Tipo_Entrega;
            ordenUbicacion.Ubicacion_Id = _Orden.Ubicacion_Id;
            ordenUbicacion.Suc_Factura = _Orden.Suc_Factura;

            const articulosTotales = await this.obtenerArticulos(_Orden.Orden_Id, Espar);

            let listaSub = await this.cargar_Suborden_Encabezado_Par_Listar(_Orden.Orden_Id, Espar);

            let _Registro_SubordenExite = [];
            _Registro_SubordenExite = listaSub.filter((item) => item.Suc_Id == this.props.sucursal.Id && item.Orden_Id == _Orden.Orden_Id)
            if (_Registro_SubordenExite.length > 0) {

                const Estructura_Disponible_Orden = await this.Calcula_Diferencia_Orden(_Orden.Orden_Id, _Orden.Fec_Activar, listaSub, _Orden.Estatus_id);

                let segundos = ((Estructura_Disponible_Orden.Disponible.getTime() / 1000) - (new Date('1970/01/01').getTime() / 1000));
                ordenUbicacion.Disponible = toDDHHMMSS(segundos).join('');
                ordenUbicacion.Disponible_Positivo = Estructura_Disponible_Orden.Disponible_Positivo;
                ordenUbicacion.Estado = Estructura_Disponible_Orden.Estatus_subOrdenNombre;

                const _SucLog = this.props.sucursal.Id;
                const articulos = articulosTotales.filter((item) => item.Suc_Id == _SucLog);
                const articulosAp = articulosTotales.filter((item) => item.Suc_Id != _SucLog);

                const sucApoyo = [...new Set(articulosAp.map(x => x.Suc_Id))];
                const sucTiempo = [...new Set(articulosTotales.map(x => x.Suc_Id))];
                let infoboxes = this.state.infoboxes;

                let center = [...this.state.center];
                let _Longitud = (_Orden.Longitud == 0 ? center[1] : _Orden.Longitud);
                let _Latitud = (_Orden.Latitud == 0 ? center[0] : _Orden.Latitud);
                center[1] = _Longitud;
                center[0] = _Latitud;
                infoboxes = [{}];

                let pushPins = [
                    {
                        "location": [_Latitud, _Longitud], "option": { title: `Orden: ${_Orden.Orden_Id.toString()}`, color: 'green', icon: ImagenesRutas.Ping }, "addHandler": { "type": "click", callback: () => { } }
                    }
                ];
                //aqui se mandaria las rutas de lo reprtidores
                let directions = {
                    "requestOptions": { "routeMode": "driving", "maxRoutes": 4 },
                    "wayPoints": [
                        {
                            //address: 'San Jose, Costa Rica'
                            "location": [this.props.mapa.Latitud, this.props.mapa.Longitud]  //[9.991800, -84.233905]
                        }
                    ]
                }
                let zoom = 18;
                const boundary = { "search": `${_Latitud.toString()} , ${_Longitud.toString()}`, "polygonStyle": { fillColor: 'rgba(161,224,255,0.4)', strokeColor: '#a495b2', strokeThickness: 2 }, "option": { entityType: 'PopulatedPlace' } }

                const tiemposDetalle = {
                    Orden: _Orden.Tiempo_Orden,
                    EstadoOrden: _Orden.Estado_Tiempo_Orden,
                    Despacho: _Orden.Tiempo_Despacho,
                    EstadoDespacho: _Orden.Estado_Tiempo_Despacho,
                    Factura: _Orden.Tiempo_Factura,
                    EstadoFactura: _Orden.Estado_Tiempo_Factura,
                    Ruta: _Orden.Tiempo_Ruta,
                    EstadoRuta: _Orden.Estado_Tiempo_Ruta
                };


                this.setState({
                    listPagos, listTiempos, esEcommerce, Datos, ordenGrupo, ordenUbicacion, articulos, articulosAp, sucApoyo, infoboxes, pushPins, directions,
                    articulosTotales, zoom, boundary, tiemposDetalle, liquidar, sucTiempo
                });
            } else {
                Notificacion.error('Orden no existe');
            }
        } else {
            Notificacion.error('Orden no existe');
        }
    }

    cargarTiempos = async () => {
        if (this.props.token) {
            const response = await Tiempos_Lista(this.props.token, this.props.empresa.Id);
            if (response.Exitoso) {
                return response.Datos;
            }
            else {
                Notificacion.error(response.Mensaje);
                return [];
            }
        }
    }

    Calcula_Diferencia_Orden = async (pOrden, pOrden_Fec_Activar, pExp_Encabezado_Suborden, pEstatus) => {
        let _Registro_Suborden = {};
        let _Estatus_Suborden = "";
        let _Duracion = new Date("1970/01/01");
        let _Disponible = new Date("1970/01/01");
        let _Disponible_Positivo = false;
        let _Retorna_Estructura = this.state.Estructura_Disponible_Orden;
        let _Fecha_Hora_Actual = Date();
        let _Orden_Fec_Activar = new Date(pOrden_Fec_Activar);
        let _ListaTiempo = [];
        let _Tiempo_Orden = new Date("1970/01/01");
        let _Tiempo_Despacho = new Date("1970/01/01");
        let _Suborden_Fec_Despacho = new Date("1970/01/01");
        let _Maximo = [];
        _ListaTiempo = await this.cargarTiempos();
        _ListaTiempo.map((item) => {
            if (item.Estatus_Id === Config.c_Estatus_Operador) {
                _Maximo = item.MaximoStr.split(':');
                _Tiempo_Orden = new Date('1970/01/01 ' + _Maximo[1] + ':' + _Maximo[2] + ':00');
            }

            if (item.Estatus_Id === Config.c_Estatus_Despachada) {
                _Maximo = item.MaximoStr.split(':');
                _Tiempo_Despacho = new Date('1970/01/01 ' + _Maximo[1] + ':' + _Maximo[2] + ':00');
            }
        })


        _Fecha_Hora_Actual = new Date(); //pCallCenter.General.General_Detalle(pCallCenter.Seguridad.Usuario.Llave).FechaActual
        _Registro_Suborden = pExp_Encabezado_Suborden.filter((item) => item.Suc_Id == this.props.sucursal.Id && item.Orden_Id == pOrden)
        _Estatus_Suborden = _Registro_Suborden[0].Estatus_Id;
        _Suborden_Fec_Despacho = new Date(_Registro_Suborden[0].Fec_Despacho);


        if (_Registro_Suborden[0].Estatus_Id === Config.c_Estatus_Operador) {
            _Duracion.setSeconds(Math.abs(((_Orden_Fec_Activar.getTime() - _Fecha_Hora_Actual.getTime()) / 1000)));

            if (pEstatus === Config.c_Estatus_Operador) {
                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Orden.getTime()) / 1000)));

            } else {

                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Despacho.getTime()) / 1000)));
            }
        } else if (_Registro_Suborden[0].Estatus_Id === Config.c_Estatus_Despachada) {

            _Duracion.setSeconds(Math.abs(((_Suborden_Fec_Despacho.getTime() - _Fecha_Hora_Actual.getTime()) / 1000)));
            if (pEstatus === Config.c_Estatus_Operador) {
                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Orden.getTime()) / 1000)));

            } else {

                _Disponible.setSeconds(Math.abs(((_Duracion.getTime() - _Tiempo_Despacho.getTime()) / 1000)));

            }
        }

        if (pEstatus === Config.c_Estatus_Operador) {

            _Disponible_Positivo = ((_Tiempo_Orden.getTime() - _Duracion.getTime()) / 1000) >= 0;
        } else {

            _Disponible_Positivo = false;
        }



        _Retorna_Estructura.Disponible = _Disponible;
        _Retorna_Estructura.Duracion = _Duracion;
        _Retorna_Estructura.Disponible_Positivo = _Disponible_Positivo;
        _Retorna_Estructura.Estatus_Suborden = _Estatus_Suborden;
        _Retorna_Estructura.Estatus_subOrdenNombre = _Registro_Suborden[0].EstatusNombre;
        return _Retorna_Estructura;
    }

    liquidar_Orden = async (pOrden, pRepartidor) => {
        let usuarioTemp = localStorageObject.get("UID");
        usuarioTemp = usuarioTemp ? usuarioTemp : -1;
        Swal.fire({
            title: "Liquidar Orden",
            html: "<h4>¿Realmente desea liquidar No." + pOrden.toString() + " ?</h4>",
            showCancelButton: true,
            confirmButtonText: "<h5>Sí</h5>",
            cancelButtonText: "<h5>No</h5>",
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                this.liquidarOrdenExpress(pOrden, pRepartidor, usuarioTemp);
            }
        });
    }

    liquidarOrdenExpress = async (pOrden, pRepartidor, pUsuario) => {
        let resultado = '';
        let _liquidar = await this.validaOrden(pOrden);
        if (_liquidar == true) {
            resultado = await Liquidar_Orden_Express(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, pOrden, pRepartidor, pUsuario);
            if (!resultado.trim()) {
                Notificacion.success('Se liquidó la orden con éxito');
            }
            else {
                Notificacion.error('Error: ' + resultado);
            }
        }
        this.limpiaPantalla();
        return resultado;
    }

    validaOrden = async (pOrden) => {
        let _Orden = await this.cargar_Orden_Encabezado_Par_Detalle(pOrden);
        let liquidar = false;
        if (_Orden == null) {
            _Orden = await this.cargar_Orden_Encabezado_Detalle(pOrden);
        }
        if (_Orden != null) {
            liquidar = !_Orden.Liquidada;

            if (liquidar == true) {
                liquidar = (_Orden.Estatus_id == Config.c_Estatus_Ruta || _Orden.Estatus_id == Config.c_Estatus_Terminada) ? true : false;
                if (liquidar == false) {
                    Notificacion.error('La orden está en un estado que no permite liquidar');
                }
            } else {
                Notificacion.error('Esta orden ya había sido liquidada');
            }
        } else {
            Notificacion.error('Orden no existe');
        }
        return liquidar;
    }


    render() {
        const { Datos, listPagos, listTiempos, columnasPagos, columnasTiempos, ordenUbicacion, esEcommerce, ordenGrupo, articulos, articulosAp, sucApoyo, sucTiempo, bingmapKey, infoboxes, pushPins, directions, center, zoom, boundary, fecha_activa,
            filtro, OrdenId, menuId, opcionValidar, showModalSeguridad, tiemposDetalle, liquidar
        } = this.state

        return (
            <Fragment>

                <LiquidarOrdenInt
                    Datos={Datos}
                    OrdenId={OrdenId}
                    listPagos={listPagos}
                    listTiempos={listTiempos}
                    columnasPagos={columnasPagos}
                    columnasTiempos={columnasTiempos}
                    ordenUbicacion={ordenUbicacion}
                    esEcommerce={esEcommerce}
                    ordenGrupo={ordenGrupo}
                    onClickOrdenes={this.onClickOrdenes}
                    onKeyPressBuscar={this.onKeyPressBuscar}
                    onClickBuscar={this.onClickBuscar}
                    onClickLiquidar={this.onClickLiquidar}
                    articulos={articulos}
                    articulosAp={articulosAp}
                    sucApoyo={sucApoyo}
                    bingmapKey={bingmapKey}
                    infoboxes={infoboxes}
                    pushPins={pushPins}
                    directions={directions}
                    center={center}
                    zoom={zoom}
                    boundary={boundary}
                    onChangeBuscar={this.onChangeBuscar}
                    onChangeFechaActiva={this.onChangeFechaActiva}
                    fecha_activa={fecha_activa}
                    tiemposDetalle={tiemposDetalle}
                    onClickDespachoHandler={this.onClickDespachoOrdenHandler}
                    onClickImprimirHandler={this.onClickImprimirHandler}
                    filtro={filtro}
                    liquidar={liquidar}
                    sucTiempo={sucTiempo}
                />
                <ModalSeguridad
                    token={this.props.token}
                    menuId={menuId}
                    opcionId={opcionValidar}
                    show={showModalSeguridad}
                    onActionResult={this.onActionResultModal}
                    onHide={this.handleCerrarModal}
                    activoAD={this.state.activoAD}
                />
            </Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter,
        mapa: state.parametros.mapa
    };
};

export default connect(mapStateToProps)(withRouter(memo(LiquidarOrden)));